import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface StreetsState {
  visible: boolean;
  searchQuery: string;
}

const initialState: StreetsState = {
  visible: false,
  searchQuery: "",
};

export const streetsSlice = createSlice({
  name: "streets",
  initialState,
  reducers: {
    toggleVisibility: (state) => {
      state.visible = !state.visible;
      if (!state.visible) {
        state.searchQuery = "";
      }
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
      if (action.payload !== "") {
        state.visible = true;
      }
    },
  },
});

export const { toggleVisibility, setSearchQuery } = streetsSlice.actions;
export default streetsSlice.reducer;
